module.exports = __webpack_public_path__ + "media/starfox.2b1dc7e2.webm";